export default {
  'dynamic-bundle:personal-box:message:no-products':
    'In deze categorie is er op dit moment geen passende aanbeveling voor je',
  'dynamic-bundle:personal-box:message:no-category': 'Geen {category} gekozen',
  'dynamic-bundle:personal-box:title:with-pet': `Persoonlijke proefbox voor {suffix}`,
  'dynamic-bundle:personal-box:title': `Persoonlijke proefbox {suffix}`,
  'dynamic-bundle:personal-box:default-title': `Persoonlijke proefbox`,
  'dynamic-bundle-controller:for': 'voor',
  'dynamic-bundle:personal-box:with': 'met',
  'dynamic-bundle-controller:with:allergies': 'Ingrediënten uitsluiten',
  'dynamic-bundle-controller:with:preferences': 'Ingrediënten voortrekken',
  'dynamic-bundle:usp:personalized:dog': 'Passend bij de behoeften & voorkeuren van je viervoeter',
  'dynamic-bundle:usp:personalized:cat': 'Passend bij de behoeften & voorkeuren van je poes',
  'dynamic-bundle:usp:test-multiple': 'Makkelijk verschillende producten testen',
  'dynamic-bundle:usp:fast-start': 'Snel starten – geen gedoe voor jou',
  'dynamic-bundle:bundle-preview:image-alt': 'Productafbeelding',
  'dynamic-bundle:button:see-details': 'Details bekijken',
  'dynamic-bundle:button:add-to-cart': 'In het winkelmandje',
  'dynamic-bundle:product:ingredients': 'Ingrediënten',
  'dynamic-bundle:product:no-content': 'Geen inhoud beschikbaar',
  'dynamic-bundle-controller:price:title': 'Prijs van je box',
  'dynamic-bundle-controller:button:add-to-cart': 'In het winkelmandje',
  'dynamic-bundle-controller:error:not-enough-products':
    'Je hebt {min} producten nodig om je box samen te stellen',
  'dynamic-bundle-controller:tooltip:warning:max-products-exceeded':
    'Geen andere passende producten beschikbaar',
  'dynamic-bundle-controller:tooltip:warning:increased': 'Product toegevoegd',
  'dynamic-bundle-controller:tooltip:warning:decreased': 'Product verwijderd',
  'dynamic-bundle:illustration': 'Illustratie van een dynamisch productpakket',
  'dynamic-bundle:subscription-overlay:title': 'Nu met bespaarabonnement: makkelijk & ontspannen',
  'dynamic-bundle:subscription-overlay:benefit:pause-cancel': 'Altijd pauzeren of opzeggen',
  'dynamic-bundle:subscription-overlay:benefit:flexible-products': 'Producten flexibel aanpassen',
  'dynamic-bundle:subscription-overlay:benefit:discount': '{discount}% korting op elke levering',
  'dynamic-bundle:subscription-overlay:price:this-delivery': 'Deze levering',
  'dynamic-bundle:subscription-overlay:price:further-deliveries': 'Elke volgende levering',
  'dynamic-bundle:subscription-overlay:price:interval': '(elke {weeks} weken)',
  'dynamic-bundle:subscription-overlay:button:subscribe':
    'Met bespaarabonnement in het winkelmandje',
  'dynamic-bundle:subscription-overlay:button:one-time': 'Eenmalig kopen',
  'personalised-bundle:headline': 'Twijfel je nog? Begin met je gepersonaliseerde proefpakket',
  'personalised-bundle:subline':
    '{count} recepten, perfect afgestemd op de behoeften & voorkeuren van je hond',
  'personalised-bundle:cta': 'Proefpakket in het winkelmandje',
  'personalised-bundle:image-alt': 'Gepersonaliseerd proefpakket voor je hond',
};
